<template>
  <nav
    aria-label="Primary navigation"
    class="fixed bottom-4 left-1/2 z-40 w-[248px] max-w-[calc(100%-2rem)] -translate-x-1/2 rounded-full bg-dark p-1.5 shadow-xl ring-1 ring-black/10"
  >
    <div class="relative flex h-16 items-center">
      <div
        class="pointer-events-none absolute left-0 top-1/2 h-12 w-12 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white shadow-sm transition-[left] duration-300 ease-out"
        :style="{ left: `${(activeIndex + 0.5) * 25}%` }"
      />
      <router-link
        v-for="item in navItems"
        :key="item.path"
        :to="item.path"
        :aria-label="item.label"
        class="relative z-10 flex h-full min-w-0 flex-1 flex-col items-center justify-center rounded-full px-1 transition-colors duration-200"
        :class="isActive(item.path) ? 'text-primary' : 'text-white/60 hover:bg-white/10 hover:text-white'"
      >
        <component
          :is="isActive(item.path) ? item.iconActive : item.icon"
          :class="[
            'transition-all duration-300 ease-out',
            isActive(item.path) ? 'h-7 w-7' : 'h-5 w-5'
          ]"
        />
        <span class="sr-only">{{ item.label }}</span>
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import {
  HomeIcon,
  CameraIcon,
  ClockIcon,
  UserIcon
} from '@heroicons/vue/24/solid'
import {
  HomeIcon as HomeIconOutline,
  CameraIcon as CameraIconOutline,
  ClockIcon as ClockIconOutline,
  UserIcon as UserIconOutline
} from '@heroicons/vue/24/outline'

const route = useRoute()

const navItems = [
  {
    path: '/',
    label: 'Home',
    icon: HomeIconOutline,
    iconActive: HomeIcon
  },
  {
    path: '/absensi',
    label: 'Attendance',
    icon: CameraIconOutline,
    iconActive: CameraIcon
  },
  {
    path: '/history',
    label: 'History',
    icon: ClockIconOutline,
    iconActive: ClockIcon
  },
  {
    path: '/profile',
    label: 'Profile',
    icon: UserIconOutline,
    iconActive: UserIcon
  }
]

const isActive = (path) => {
  if (path === '/') {
    return route.path === '/'
  }
  return route.path.startsWith(path)
}

const activeIndex = computed(() => {
  const index = navItems.findIndex(item => isActive(item.path))
  return index < 0 ? 0 : index
})
</script>
